import React from 'react';
import {
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import { Dialog } from "@mui/material";
import { DialogProps } from "@mui/material/Dialog/Dialog";

export interface OrderReceiptDialogProps extends Omit<DialogProps, "onClose"> {
    receiptId: string;
    onClose: () => void;
}

export default function OrderReceiptDialog(props: OrderReceiptDialogProps): JSX.Element {
    const {
        receiptId,
        onClose,
        ...other
    } = props;

    const handleClose = () => {
        onClose();
    };

    return (
        <Dialog
            onClose={handleClose}
            {...other}
        >
            <DialogTitle>{`Order receipt ${receiptId}`}</DialogTitle>
            <DialogContent>
                <iframe
                    src={`/orderreceipt/${receiptId}`}
                    width={800}
                    height={600}
                />
            </DialogContent>
            <DialogActions>
                <Button name="opentab" onClick={() =>  window.open(`/orderreceipt/${receiptId}`)} color="primary" autoFocus>
                    Open in a new tab
                </Button>
                <Button name="close" onClick={handleClose} color="primary" autoFocus>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}
